import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class PackagetourService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('packagetour/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('packagetour/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('packagetour/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('packagetour/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('packagetour/update', val_id, data);
  }

  updateSave(data: any) {
    return this.restService.save('packagetour/update/save', data);
  }

  updateVideo(val_id: number, data: any) {
    return this.restService.update('packagetour/update/video', val_id, data);
  }

  saveImage(data: any) {
    return this.restService.save('packagetour/save/image', data);
  }

  delete(val_id: number) {
    return this.restService.delete('packagetour/delete', val_id);
  }

  // packagetour - category
  allCategoryPackage(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/category/packagetour/all', val_params);
  }

  saveCategoryPackage(data: any) {
    return this.restService.save('config/category/packagetour/save', data);
  }

  // packagetour - category
  allTypePackage(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/type/packagetour/all', val_params);
  }

  allTypePricePackage(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typeprice/packagetour/all', val_params);
  }

  getToursAssociates(val_id: number) {
    return this.restService.get('packagetour/tours/associates', val_id);
  }

  getTemplatesPackage(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/templates/packages/all', val_params);
  }
}
